var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Tooltip as MuiTooltip } from '@mui/material';
import { Info, InfoDarkSmall } from '../../assets';
import colors from '../../themes/colors';
var Tooltip = function (_a) {
    var title = _a.title, children = _a.children, _b = _a.size, size = _b === void 0 ? 'medium' : _b, _c = _a.placement, placement = _c === void 0 ? 'bottom' : _c, _d = _a.theme, theme = _d === void 0 ? 'dark' : _d, _e = _a.delay, delay = _e === void 0 ? 250 : _e, _f = _a.arrow, arrow = _f === void 0 ? false : _f, _g = _a.info, info = _g === void 0 ? false : _g;
    var content = children;
    if (!info && !children)
        return null;
    if (info) {
        content = _jsx(Info, {});
        if (size === 'small')
            content = _jsx(InfoDarkSmall, {});
    }
    var backgroundColor = theme === 'dark' ? colors.neutral100 : colors.white;
    var color = theme === 'dark' ? colors.white : colors.neutral100;
    return (_jsx(MuiTooltip, __assign({ enterDelay: delay, title: title, placement: placement, arrow: arrow, componentsProps: { tooltip: { sx: { backgroundColor: backgroundColor, color: color } }, arrow: { sx: { color: backgroundColor } } } }, { children: content })));
};
export default Tooltip;
